<div class="flex flex-col w-full !h-full">
    <!-- LOADER -->
    <mat-progress-bar
        *ngIf="progress || silentProgress"
        mode="indeterminate" color="primary"
        class="sticky top-0 left-0 z-99999"></mat-progress-bar>

    <!-- View mode -->
    <ng-container *ngIf="!editMode ">

        <!-- Header -->
        <!--        <div class="relative w-full h-40 sm:h-48 px-8 sm:px-12 bg-accent-100 dark:bg-accent-700">-->
        <!--            &lt;!&ndash; Background &ndash;&gt;-->
        <!--            <ng-container>-->
        <!--                <img-->
        <!--                        class="absolute inset-0 object-cover w-full h-full"-->
        <!--                        src="assets/images/sample/treated_wood.jpeg">-->
        <!--            </ng-container>-->
        <!--            &lt;!&ndash; Close button &ndash;&gt;-->
        <!--            &lt;!&ndash;            <div class="flex items-center justify-end w-full max-w-3xl mx-auto pt-6">&ndash;&gt;-->
        <!--            &lt;!&ndash;                <button&ndash;&gt;-->
        <!--            &lt;!&ndash;                    mat-icon-button&ndash;&gt;-->
        <!--            &lt;!&ndash;                    [matTooltip]="'Close'"&ndash;&gt;-->
        <!--            &lt;!&ndash;                    [routerLink]="['../']">&ndash;&gt;-->
        <!--            &lt;!&ndash;                    <mat-icon&ndash;&gt;-->
        <!--            &lt;!&ndash;                        class="dark:text-white text-primary"&ndash;&gt;-->
        <!--            &lt;!&ndash;                        [svgIcon]="'heroicons_outline:x'"></mat-icon>&ndash;&gt;-->
        <!--            &lt;!&ndash;                </button>&ndash;&gt;-->
        <!--            &lt;!&ndash;            </div>&ndash;&gt;-->
        <!--        </div>-->

        <!-- Access -->
        <div class="h-full relative flex flex-col flex-auto items-center p-6 pt-0 sm:p-12 sm:pt-0">
            <div *ngIf="absence && absence.id" class="w-full max-w-3xl">

                <!-- Avatar and actions -->
                <div class="flex flex-auto items-end mt-8">
                    <!-- Avatar -->
                    <!--                    <div-->
                    <!--                        class="flex items-center justify-center w-32 h-32 rounded-full overflow-hidden ring-4 ring-bg-card">-->
                    <!--                        <div-->
                    <!--                            class="flex items-center justify-center w-full h-full rounded overflow-hidden uppercase text-8xl font-bold leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">-->
                    <!--                            <span *ngIf="attribute.id !== 'new'">{{truck.description}}</span>-->
                    <!--                            <span *ngIf="attribute.id === 'new'">N</span>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!-- Actions -->
                    <div class="flex items-center mr-auto mb-1">
                        <button
                            mat-stroked-button
                            [disabled]="progress"
                            [routerLink]="['../']">
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'mat_outline:close'"></mat-icon>
                            <span class="ml-2">{{ "CLOSE" | transloco }}</span>
                        </button>
                    </div>
                    <div class="flex items-center ml-auto mb-1">

                        <!--  BUTTON -->
                        @if (!absence.status) {

                            <button
                                mat-stroked-button
                                [disabled]="progress"
                                (click)="toggleEditMode(true)">
                                <mat-icon
                                    class="icon-size-5"
                                    [svgIcon]="'heroicons_outline:pencil'"></mat-icon>
                                <span class="ml-2">{{ "ABSENCES.EDIT_ABSENCE" | transloco }}</span>
                            </button>

                        }

                        <!-- EDIT BUTTON -->
                        <button
                            mat-stroked-button
                            [disabled]="progress"
                            (click)="toggleEditMode(true)">
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_outline:pencil'"></mat-icon>
                            <span class="ml-2">{{ "ABSENCES.EDIT_ABSENCE" | transloco }}</span>
                        </button>
                    </div>
                </div>

                <!-- CONTACT TITLE -->
                <div class="w-full mt-8 text-3xl font-bold truncate break-words">
                    <span *ngIf="absence?.id === 'new'">{{ "ABSENCES.NEW_ABSENCE" | transloco }}</span>
                    <span *ngIf="absence?.id !== 'new'">{{ "ABSENCES.EDIT_ABSENCE" | transloco }}</span>
                </div>

                <div *ngIf="absence?.id !== 'new'" class="flex flex-col mt-4 pt-6 border-t space-y-6">

                    <!-- ABSENCE STATUS -->
<!--                    <div class="flex">-->
<!--                        <mat-icon [svgIcon]="'feather:monitor'"></mat-icon>-->
<!--                        <div class="min-w-0 ml-6 space-y-1">-->
<!--                            <div class="flex-col items-center leading-6">-->
<!--                                <div class="flex flex-row items-center justify-start space-x-2">-->
<!--                                    <span>{{ "ABSENCES.STATUS" | transloco }}: </span>-->
<!--                                    <app-production-status-badge class="!m-0"-->
<!--                                                                 [which]="'absence'"-->
<!--                                                                 [clickable]="true"-->
<!--                                                                 (statusChange)="onStatusChanged($event)"-->
<!--                                                                 [statusId]="absence.status"></app-production-status-badge>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

                    <!-- ABSENCE USER -->
                    <div class="flex">
                        <mat-icon [svgIcon]="'heroicons_outline:user'"></mat-icon>
                        <div class="min-w-0 ml-6 space-y-1">
                            <div class="flex-col items-center leading-6">
                                <div>{{ "ABSENCES.EMPLOYEE" | transloco }}
                                    : {{ absence.user.first_name }} {{ absence.user.last_name }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- USER POSITION -->
<!--                    <div *ngIf="absence.user" class="flex">-->
<!--                        <mat-icon [svgIcon]="'heroicons_outline:academic-cap'"></mat-icon>-->
<!--                        <div class="min-w-0 ml-6 space-y-1">-->
<!--                            <div class="flex-col items-center leading-6">-->
<!--                                <div>{{ "CUSTOMERS.CONTACTS.POSITION" | transloco }}-->
<!--                                    : {{ absence.user.position }}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

                    <!-- CONTACT PHONE -->
                    <div *ngIf="absence.user.phone" class="flex">
                        <mat-icon [svgIcon]="'heroicons_outline:phone'"></mat-icon>
                        <div class="min-w-0 ml-6 space-y-1">
                            <div class="flex-col items-center leading-6">
                                <div>
                                    {{ "CUSTOMERS.CONTACTS.PHONE" | transloco }}:
                                    <a class="hover:underline text-primary-500"
                                       [href]="'tel:' + absence.user.phone"
                                       target="_blank">
                                        {{ absence.user.phone }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- CONTACT EMAIL -->
                    <div *ngIf="absence.user.email" class="flex">
                        <mat-icon [svgIcon]="'heroicons_outline:envelope'"></mat-icon>
                        <div class="min-w-0 ml-6 space-y-1">
                            <div class="flex-col items-center leading-6">
                                <div>
                                    {{ "CUSTOMERS.CONTACTS.EMAIL" | transloco }}:
                                    <a
                                        class="hover:underline text-primary-500"
                                        [href]="'mailto:' + absence.user.email"
                                        target="_blank">
                                        {{ absence.user.email }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ABSENCE DURATION -->
                    <div class="flex">
                        <mat-icon [svgIcon]="'heroicons_outline:clock'"></mat-icon>
                        <div class="min-w-0 ml-6 space-y-1">
                            <div class="flex-col items-center leading-6">
                                <div>{{ "ABSENCES.FROM" | transloco }} - {{ "ABSENCES.TO" | transloco }}
                                    : {{ absence.from_date | date:'dd. MM. YYYY' }} -
                                    {{ absence.to_date | date:'dd. MM. YYYY' }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ABSENCE TYPE -->
                    <div class="flex">
                        <mat-icon [svgIcon]="'heroicons_outline:clock'"></mat-icon>
                        <div class="min-w-0 ml-6 space-y-1">
                            <div class="flex-col items-center leading-6">
                                <div>{{ "ABSENCES.TYPE" | transloco }}: {{ absence.absence_type.name }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- ABSENCE ADDITIONAL -->
                    @if (absence.additional) {

                        <div class="flex">
                            <mat-icon [svgIcon]="'mat_outline:info'"></mat-icon>
                            <div class="min-w-0 ml-6 space-y-1">
                                <div class="flex-col items-center leading-6">
                                    <div>{{ "ABSENCES.ADDITIONAL" | transloco }}: {{ absence.additional }}
                                    </div>
                                </div>
                            </div>
                        </div>

                    }


                    <!-- ABSENCE STATUS -->
<!--                    <hr class="my-3">-->
<!--                    <activity-->
<!--                        class="w-full relative"-->
<!--                        [titleClasses]="'mb-3 text-3xl'"-->
<!--                        [titleText]="'HISTORY_FEED'"-->
<!--                        [descriptionText]="null"-->
<!--                        [additionalClasses]="''"-->
<!--                        [entityId]="absence?.id"-->
<!--                        [entityType]="utils.ENTITY_TYPE_ABSENCE"-->
<!--                        [activityGroup]="'status'"></activity>-->

                    <!-- ABSENCE COMMENTS -->
<!--                    <activity-->
<!--                        class="w-full relative"-->
<!--                        [titleClasses]="'mb-6 text-3xl'"-->
<!--                        [titleText]="'COMMENTS'"-->
<!--                        [descriptionText]="null"-->
<!--                        [additionalClasses]="''"-->
<!--                        [entityType]="utils.ENTITY_TYPE_ABSENCE"-->
<!--                        [entityId]="absence?.id"-->
<!--                        [activityGroup]="'comment'"></activity>-->

                    <!-- CONTACT POSITION -->
                    <!--                    <div *ngIf="absence.position" class="flex">-->
                    <!--                        <mat-icon [svgIcon]="'heroicons_outline:academic-cap'"></mat-icon>-->
                    <!--                        <div class="min-w-0 ml-6 space-y-1">-->
                    <!--                            <div class="flex-col items-center leading-6">-->
                    <!--                                <div>{{ "CUSTOMERS.CONTACTS.POSITION" | transloco }}-->
                    <!--                                    : {{ absence.position }}-->
                    <!--                                </div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->

                    <!-- CONTACT DEFAULT -->
                    <!--                    <div class="flex">-->
                    <!--                        <mat-icon [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>-->
                    <!--                        <div class="min-w-0 ml-6 space-y-1">-->
                    <!--                            <div class="flex-col items-center leading-6">-->
                    <!--                                <div class="flex items-center justify-start">-->
                    <!--                                    <span class="mr-2">{{ "CUSTOMERS.CONTACTS.IS_DEFAULT" | transloco }}:</span>-->

                    <!--                                    <ng-container *ngIf="contact.is_default">-->
                    <!--                                        <mat-icon-->
                    <!--                                                class="text-green-400 icon-size-5"-->
                    <!--                                                [svgIcon]="'heroicons_solid:check'"></mat-icon>-->
                    <!--                                    </ng-container>-->
                    <!--                                    <ng-container *ngIf="!contact.is_default">-->
                    <!--                                        <mat-icon-->
                    <!--                                                class="text-warn-400 icon-size-5"-->
                    <!--                                                [svgIcon]="'heroicons_solid:x'"></mat-icon>-->
                    <!--                                    </ng-container>-->

                    <!--                                </div>-->

                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->

                    <!-- CONTACT AVAILABILITY -->
                    <!--                    <div class="flex">-->
                    <!--                        <mat-icon [svgIcon]="'heroicons_outline:eye'"></mat-icon>-->
                    <!--                        <div class="min-w-0 ml-6 space-y-1">-->
                    <!--                            <div class="flex-col items-center leading-6">-->
                    <!--                                <div class="flex items-center justify-start">-->
                    <!--                                    <span class="mr-2">{{ "STATUS" | transloco }}:</span>-->

                    <!--                                    <ng-container *ngIf="contact.status">-->
                    <!--                                        <mat-icon-->
                    <!--                                                class="text-green-400 icon-size-5"-->
                    <!--                                                [svgIcon]="'heroicons_solid:check'"></mat-icon>-->
                    <!--                                    </ng-container>-->
                    <!--                                    <ng-container *ngIf="!contact.status">-->
                    <!--                                        <mat-icon-->
                    <!--                                                class="text-warn-400 icon-size-5"-->
                    <!--                                                [svgIcon]="'heroicons_solid:x'"></mat-icon>-->
                    <!--                                    </ng-container>-->

                    <!--                                </div>-->

                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->

                </div>
            </div>
        </div>
    </ng-container>

    <!-- EDIT MODE -->
    <ng-container *ngIf="editMode">

        <!-- HEADER -->
        <!--        <div class="relative w-full h-40 sm:h-40 px-8 sm:px-12 bg-accent-100 dark:bg-accent-700">-->
        <!--            &lt;!&ndash; BACKGROUND &ndash;&gt;-->
        <!--            <ng-container>-->
        <!--                <img-->
        <!--                        class="absolute inset-0 object-cover w-full h-full"-->
        <!--                        src="assets/images/sample/treated_wood.jpeg">-->
        <!--            </ng-container>-->
        <!--            &lt;!&ndash; Close button &ndash;&gt;-->
        <!--            &lt;!&ndash; <div class="flex items-center justify-end w-full max-w-3xl mx-auto pt-6">-->
        <!--                <button-->
        <!--                    mat-icon-button-->
        <!--                    [matTooltip]="'Close'"-->
        <!--                    [routerLink]="['../']">-->
        <!--                    <mat-icon-->
        <!--                        class="dark:text-white text-primary"-->
        <!--                        [svgIcon]="'heroicons_outline:x'"></mat-icon>-->
        <!--                </button>-->
        <!--            </div> &ndash;&gt;-->
        <!--        </div>-->

        <div class="h-full relative flex flex-col flex-auto items-center p-6 pt-0 sm:p-12 sm:pt-0">

            <!-- CONTACTS TITLE -->
            <div class="w-full mt-8 text-3xl font-bold truncate break-words">
                <span *ngIf="absence?.id === 'new'">{{ "ABSENCES.NEW_ABSENCE" | transloco }}: {{ absence?.user?.first_name }} {{ absence?.user?.last_name }}</span>
                <span *ngIf="absence?.id !== 'new'">{{ "ABSENCES.EDIT_ABSENCE" | transloco }}</span>
            </div>

            <!-- ACCESS FORM -->
            <div class="w-full relative flex flex-col flex-auto items-center pt-4 h-full border-t mt-4 space-y-6">
                <div class="w-full h-full max-w-3xl">
                    @if (form) {
                        <form [formGroup]="form">

                            <div
                                class="w-full flex-row items-center justify-between xs:flex-col xs:items-start xs:justify-start">

                                <div class="flex flex-col space-x-0 w-full flex-wrap">

                                    <div class="flex flex-col items-start justify-center">

                                        <!-- ABSENCE DATE RANGE PERIOD -->
                                        <mat-form-field class="w-full" appearance="fill">
                                            <mat-label>
                                                {{"ABSENCES.FROM" | transloco}}
                                                - {{"ABSENCES.TO" | transloco}}
                                            </mat-label>
                                            <mat-date-range-input
                                                [max]="maxDate"
                                                [dateFilter]="absenceDatesFilter"
                                                [rangePicker]="picker">
                                                <input matStartDate
                                                       (dateChange)="fromDatetimeChanged($event)"
                                                       [formControlName]="'from_date'"
                                                       [placeholder]="'ABSENCES.FROM' | transloco | lowercase">
                                                <input matEndDate
                                                       [formControlName]="'to_date'"
                                                       [placeholder]="'ABSENCES.TO' | transloco | lowercase">
                                            </mat-date-range-input>
                                            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-date-range-picker #picker></mat-date-range-picker>
                                            <mat-error *ngIf="form.get('from_date').errors">
                                                {{"ABSENCES.FORM_FIELDS.FROM_DATE_REQUIRED" | transloco}}
                                            </mat-error>
                                            <mat-error *ngIf="form.get('to_date').errors">
                                                {{"ABSENCES.FORM_FIELDS.TO_DATE_REQUIRED" | transloco}}
                                            </mat-error>
                                        </mat-form-field>
                                        <!-- / ABSENCE DATE RANGE PERIOD -->

                                        <!-- CLEAR DATE RANGE -->
                                        <button
                                            class="w-min my-4"
                                            [ngClass]="{'mt-8' : form.get('from_date').errors || form.get('to_date').errors}"
                                            mat-stroked-button
                                            [color]="'accent'"
                                            (click)="clearDateRange()"
                                            [disabled]="progress || (!form.getRawValue().from_date && !form.getRawValue().to_date)">
                        <span>
                            {{'ABSENCES.CLEAR_DATE_RANGE' | transloco}}
                        </span>
                                        </button>

                                        <!-- FROM DATE -->
                                        <!--                    <mat-form-field class="w-1/2">-->
                                        <!--                        <mat-label>{{"ABSENCES.FROM" | transloco}}</mat-label>-->
                                        <!--                        <mat-icon-->
                                        <!--                                matPrefix-->
                                        <!--                                class="hidden sm:flex icon-size-5"-->
                                        <!--                                [svgIcon]="'mat_outline:date_range'"></mat-icon>-->
                                        <!--                        <input-->
                                        <!--                                matInput-->
                                        <!--                                [matDatepickerFilter]="absenceDatesFilter"-->
                                        <!--                                required-->
                                        <!--                                [matDatepicker]="fromDateDatePicker"-->
                                        <!--                                [formControlName]="'from_date'"-->
                                        <!--                                placeholder="{{'ABSENCES.FROM' | transloco}}">-->
                                        <!--                        <mat-datepicker-toggle-->
                                        <!--                                matSuffix-->
                                        <!--                                [for]="fromDateDatePicker">-->
                                        <!--                        </mat-datepicker-toggle>-->
                                        <!--                        <mat-datepicker-->
                                        <!--                            #fromDateDatePicker></mat-datepicker>-->
                                        <!--                        <mat-error *ngIf="form.get('from_date').errors">-->
                                        <!--                            {{"ABSENCES.FORM_FIELDS.FROM_DATE_REQUIRED" | transloco}}-->
                                        <!--                        </mat-error>-->
                                        <!--                    </mat-form-field>-->
                                        <!-- / FROM DATE -->

                                        <!-- TO DATE -->
                                        <!--                    <mat-form-field class="w-1/2 pl-3">-->
                                        <!--                        <mat-label>{{"ABSENCES.TO" | transloco}}</mat-label>-->
                                        <!--                        <mat-icon-->
                                        <!--                                matPrefix-->
                                        <!--                                class="hidden sm:flex icon-size-5"-->
                                        <!--                                [svgIcon]="'mat_outline:date_range'"></mat-icon>-->
                                        <!--                        <input-->
                                        <!--                                matInput-->
                                        <!--                                [min]="form.getRawValue().from_date ? form.getRawValue().from_date : ''"-->
                                        <!--                                [matDatepickerFilter]="absenceDatesFilter"-->
                                        <!--                                required-->
                                        <!--                                [readonly]="!form.getRawValue().from_date || form.get('from_date').errors"-->
                                        <!--                                [disabled]="!form.getRawValue().from_date || form.get('from_date').errors"-->
                                        <!--                                [matDatepicker]="toDateDatePicker"-->
                                        <!--                                [formControlName]="'to_date'"-->
                                        <!--                                placeholder="{{'ABSENCES.TO' | transloco}}">-->
                                        <!--                        <mat-datepicker-toggle-->
                                        <!--                                matSuffix-->
                                        <!--                                [disabled]="!form.getRawValue().from_date || form.get('from_date').errors"-->
                                        <!--                                [for]="toDateDatePicker">-->
                                        <!--                        </mat-datepicker-toggle>-->
                                        <!--                        <mat-datepicker-->
                                        <!--                            #toDateDatePicker-->
                                        <!--                            [disabled]="!form.getRawValue().from_date || form.get('from_date').errors"-->
                                        <!--                        ></mat-datepicker>-->
                                        <!--                        <mat-error *ngIf="form.get('to_date').errors">-->
                                        <!--                            {{"ABSENCES.FORM_FIELDS.TO_DATE_REQUIRED" | transloco}}-->
                                        <!--                        </mat-error>-->
                                        <!--                    </mat-form-field>-->
                                        <!-- / TO DATE -->

                                    </div>

                                    <!-- TYPE OF ABSENCE -->
                                    <div class="flex">

                                        <mat-form-field class="w-full sm:w-1/2">
                                            <mat-label>{{'ABSENCES.TYPE' | transloco}}</mat-label>
                                            <mat-icon
                                                matPrefix
                                                class="hidden sm:flex icon-size-5"
                                                [svgIcon]="'mat_solid:beach_access'"></mat-icon>
                                            <mat-select required
                                                        [formControlName]="'type'">
                                                <ng-container *ngFor="let type of _absencesLeaveService.getAbsenceTypes">
                                                    <mat-option [value]="type.id">
                                                        {{type.name}}
                                                    </mat-option>
                                                </ng-container>
                                            </mat-select>
                                            <mat-error *ngIf="form.get('type').hasError('required')">
                                                {{"ABSENCES.FORM_FIELDS.TYPE_REQUIRED" | transloco}}
                                            </mat-error>
                                        </mat-form-field>

                                    </div>
                                    <!-- / TYPE OF ABSENCE -->

                                    <!-- ADDITIONAL -->
                                    <div class="flex">
                                        <mat-form-field class="w-full">
                                            <mat-label>{{'ABSENCES.ADDITIONAL' | transloco}}</mat-label>
                                            <mat-icon
                                                matPrefix
                                                class="hidden sm:flex icon-size-5"
                                                [svgIcon]="'mat_outline:info'"></mat-icon>
                                            <textarea
                                                matInput rows="3"
                                                placeholder="{{'ABSENCES.ADDITIONAL' | transloco}}"
                                                [formControlName]="'additional'"></textarea>
                                            <mat-error *ngIf="form.get('additional').hasError('required')">
                                                {{"ABSENCES.FORM_FIELDS.ADDITIONAL_REQUIRED" | transloco}}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <!-- / ADDITIONAL -->

                                </div>

                            </div>

                            <!-- DEFAULT -->
                            <!--                        <div-->
                            <!--                                class="flex flex-col mb-10">-->
                            <!--                            <span class="font-semibold mb-2">{{ 'CUSTOMERS.CONTACTS.IS_DEFAULT' | transloco }}</span>-->
                            <!--                            <mat-slide-toggle-->
                            <!--                                    [formControlName]="'is_default'"-->
                            <!--                                    [color]="'primary'">-->
                            <!--                                {{ (form.get('is_default').value ? 'YES' : 'NO') | transloco }}-->
                            <!--                            </mat-slide-toggle>-->
                            <!--                        </div>-->

                            <!-- AVAILABILITY -->
                            <!--                        <div *ngIf="actionType !== 'new'"-->
                            <!--                             class="flex flex-col mb-10">-->
                            <!--                            <span class="font-semibold mb-2">{{ 'STATUS' | transloco }}</span>-->
                            <!--                            <mat-slide-toggle-->
                            <!--                                    [formControlName]="'status'"-->
                            <!--                                    [color]="'primary'">-->
                            <!--                                {{ (form.get('status').value ? 'AVAILABLE' : 'UNAVAILABLE') | transloco }}-->
                            <!--                            </mat-slide-toggle>-->
                            <!--                        </div>-->

                            <!-- ACTIONS -->
                            <div
                                class="flex items-center mt-15 -mx-6 sm:-mx-12 py-4 pr-4 pl-1 sm:pr-12 sm:pl-7 border-t bg-gray-50 dark:bg-transparent">

                                <!-- DELETE -->
                                <button
                                    mat-button
                                    [color]="'warn'"
                                    [matTooltip]="'Delete'"
                                    [disabled]="progress"
                                    (click)="deleteAbsence()">
                                    {{ "DELETE" | transloco }}
                                </button>

                                <!-- CANCEL -->
                                <button
                                    class="ml-auto"
                                    mat-button
                                    [disabled]="progress"
                                    [matTooltip]="'Cancel'"
                                    (click)="cancel()">
                                    {{ "CANCEL" | transloco }}
                                </button>

                                <!-- SAVE -->
                                <button
                                    class="ml-2 text-white"
                                    mat-flat-button
                                    [color]="'primary'"
                                    [disabled]="form.invalid || form.pristine || progress"
                                    [matTooltip]="'Save'"
                                    (click)="updateAbsence()">
                                    <span *ngIf="actionType === 'edit'">{{ "SAVE" | transloco }}</span>
                                    <span *ngIf="actionType !== 'edit'">{{ "ADD" | transloco }}</span>
                                </button>
                            </div>

                        </form>
                    }
                </div>
            </div>

        </div>

    </ng-container>
</div>
